import {useHistory} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {Alert} from "@mui/material";
import BigSelector, {BigSelectorItem} from "../../components/common/BigSelector/BigSelector";
import {useAdminApi, ADMIN_ACCOUNTS_KEY} from "./api";

export function AdminAccountsTab() {
    var api = useAdminApi();
    var history = useHistory();

    var {data: accounts, isLoading, isError, error} = useQuery(
        [ADMIN_ACCOUNTS_KEY],
        () => api.listAccounts(),
        {staleTime: 30000}
    );

    if (isError) {
        console.error(error);
        return <BigSelector title="Accounts" emptyMessage={<Alert severity="error">Failed to load accounts</Alert>}/>;
    }

    var items: BigSelectorItem[] = (accounts || []).map((account) => ({
        id: account.key,
        name: account.key,
        subtitle: `${account.namespace} / ${account.name || "(no name)"}`,
        icon: <i className="fas fa-building"/>,
        onActivate: () => history.push(`/admin/accounts/${account.key}`),
    }));

    return (
        <BigSelector title="Accounts" items={items} loading={isLoading} emptyMessage="No accounts found"/>
    );
}
